import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import { MenuItemBook } from '../models/rich-data.model';

@Pipe({
  name: 'workingHours'
})
export class WorkingHoursPipe implements PipeTransform {

  transform(book: MenuItemBook, days: string[]): { day: string; time: string }[] {
    const RESULT = [];

    for (const day of days) {
      if (book[day]) {
        RESULT.push({
          day, time:
            `${dayjs(book.menu_item_book_details[0].start_time)
              .format('HH:mm')} - ${dayjs(book.menu_item_book_details[0].end_time).format('HH:mm')}`
        });
        continue;
      } else {
        RESULT.push({
          day, time: `Closed`
        });
      }
    }

    return RESULT;
  }

}
